import React from "react";
import { createUseStyles } from "react-jss";
import { useCategoryBySlug, useItemsByCategory } from "../DataProvider";

const BackgroundVideo =
  "https://folloze-demandbase.s3.us-west-1.amazonaws.com/db_central_bg-lime-reduced.mp4";

const useItemDesktopStyles = createUseStyles({
  featuredContentItemsText: {
    backgroundColor: "#FFF",
    padding: "5px",
  },
});

const ItemDesktop = ({ item, category }) => {
  const classes = useItemDesktopStyles();

  const handleClick = () => {
    window.FollozeApi.openItemViewer({
      item: item,
      category,
      queryString: ``,
    });
  };

  return (
    <a href={item.link} onClick={handleClick}>
      <div className="item-tile" tabIndex="0">
        {item.item_type === "brightcove" && (
          <span className="icon-play-button"></span>
        )}

        <div className="item-tile-image-wrapper">
          <div
            className="smart-image "
            style={{
              backgroundImage: `url(${item.image.url})`,
              backgroundSize: "cover",
            }}
          ></div>
        </div>
        <div className={classes.featuredContentItemsText}>
          <div className="item-title">{item.name}</div>
        </div>
        <div
          className="description-container"
          style={{ backgroundColor: "rgb(0, 78, 136)" }}
        >
          <div className="description-content">
            <div className="content-container">
              <p>{item.description}</p>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

const ItemMobile = ({ item, category }) => {
  const handleClick = () => {
    window.FollozeApi.openItemViewer({
      item: item,
      category,
      queryString: ``,
    });
  };

  return (
    <a href={item.link} onClick={handleClick}>
      <div className="item-tile-container ">
        <div className="item-tile">
          <div
            className="smart-image "
            style={{
              backgroundImage: `url(${item.image.url})`,
              backgroundSize: "cover",
            }}
          ></div>
          <div className="details">
            <div className="title">{item.name}</div>
            <p className="item-description closed">{item.description}</p>
            <div className="interactions-container"></div>
          </div>
        </div>
      </div>
    </a>
  );
};

const useFeaturedContentStyles = createUseStyles({
  featuredContent: {
    position: "relative",
    // marginBottom: "50px",
    "& .item-tile": {
      margin: "0 !important",
      width: "35rem !important",
      marginRight: "33px !important",
    },
  },
  featuredContentItems: ({ isMobile }) => ({
    paddingTop: "70px",
    paddingBottom: isMobile ? "0" : "160px",
    width: "100%",
  }),
  bannerTitle: ({ isMobile }) => ({
    color: "#25282d",
    textAlign: "center",
    marginBottom: "30px",
    zIndex: 1,
    position: "relative",
    "& h1": {
      fontFamily: "LexendDeca-Bold",
      fontSize: "5rem !important",
      fontWeight: "bold",
      lineHeight: "1.15",
      whiteSpace: "pre-line",
      marginBottom: "15px",
      "@media screen and (min-width: 2000px)": {
        fontSize: "85px !important",
      },
      "@media screen and (max-width: 990px)": {
        fontSize: "3.75rem !important",
      },
    },
    "& p": {
      fontFamily: "LexendDeca-Light",
      fontWeight: "normal",
      fontSize: isMobile ? "3rem !important" : "2rem",
      lineHeight: "150%",
      "@media screen and (min-width: 2000px)": {
        fontSize: "4.4rem !important",
      },
      "@media screen and (max-width: 990px)": {
        fontSize: "2.25rem !important",
        padding: "0 4rem",
      },
    },
  }),
  featuredContentItemsText: {
    backgroundColor: "#FFF",
    padding: "5px",
  },
  videoContainer: {
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    "& video": {
      objectFit: "cover",
      height: "100%",
      width: "100vw",
    },
  },
  videoContainerDesktop: {
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    overflow: "hidden",
    "& video": {
      objectFit: "cover",
      height: "100%",
      width: "100vw",
    },
    "@media screen and (min-width: 1900px)": {
      "& video": {
        width: "100%",
        height: "auto",
      },
    },
  },
});

function FeaturedContent() {
  const isMobile = !!document.getElementsByClassName("live-board-mobile")[0];

  const classes = useFeaturedContentStyles({ isMobile });

  // const { initialState } = useData();

  const category = useCategoryBySlug("featured");
  const data = useItemsByCategory(category?.id);

  return (
    <div className={classes.featuredContent}>
      <div className="items-view-container">
        <div
          className={
            isMobile ? classes.videoContainer : classes.videoContainerDesktop
          }
        >
          <video
            loop
            muted
            playsInline
            style={{ backgroundSize: "cover" }}
            className={classes.featuredContentVideo}
            preload="auto"
            autoPlay
          >
            <source src={BackgroundVideo} type="video/mp4" />
          </video>
        </div>
        <div className={classes.featuredContentItems}>
          <div className={classes.banner}>
            <div className={classes.bannerTitle}>
              <h1>DB Central</h1>
              <p>
                The Definitive B2B Go-To-Market Resource Center: <br />
                The Content You Want. The Way You Want It...
              </p>
            </div>
          </div>
          <div className="items-view-content">
            <div className="category-container">
              <div
                className={isMobile ? "items-container" : "item-tile-container"}
              >
                {category &&
                  data?.map((item) => (
                    <React.Fragment key={item.id}>
                      {isMobile ? (
                        <ItemMobile item={item} category={category} />
                      ) : (
                        <ItemDesktop item={item} category={category} />
                      )}
                    </React.Fragment>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeaturedContent;
